import React, { useState } from 'react';
import { settingsFunctions } from '../../../../functions/settings';
import ButtonSelector from './ButtonSelector';
import ButtonTypeReturn from './ButtonTypeReturn';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { useAuth } from '../../../../utils/Auth';
import styles from './AddButton.module.css';

function AddButton(props) {
    const { buttons, setButtonState, setShowForm, accountType, uid, profile_theme } = props;
    const { updateVcardObject, buttonsActiveState, getButtonLink } = settingsFunctions;
    const { getUpdatedUserVcard } = useAuth();

    const [ buttonData, setButtonData ] = useState({
        data: '',
        hasChanges: false,
        icon: '',
        label: '',
        type: {},
    });
    const [ showSpinner, setShowSpinner ] = useState(false);

    const resetForm = () => {
        setButtonData(prev => ({
            ...prev,
            data: '',
            hasChanges: false,
            label: '',
        }));
    };

    const saveNewButton = async () => {
        try {
            const newButton = {
                active: true,
                added: Date.now(),
                data: buttonData.type.ref === 'phone' ? formatPhoneNumberIntl(buttonData.data) : getButtonLink(buttonData.type.ref, buttonData.data.replace(/\/$/,'')),
                icon: buttonData.icon,
                label: buttonData.label?.length > 0 ? buttonData.label : "",
                ref: buttonData.type.ref
            };
            
            const newButtonsArr = buttons ? [newButton, ...buttons] : [newButton];
            const update = { buttons: accountType === 'basic' ? buttonsActiveState(newButtonsArr) : newButtonsArr };

            setButtonState(update.buttons);
            setShowSpinner(true);
            await updateVcardObject(update, uid);
            await getUpdatedUserVcard();
            setShowSpinner(false);
            setShowForm('');
        } catch (error) {
            console.error("Error saving new button:", error);
            setShowSpinner(false);
        };
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.backBtn} onClick={() => {Object.keys(buttonData.type).length > 0 ? setButtonData(prev => ({...prev, type: {}, label: '', icon: '', hasChanges: false, data: ''})) : setShowForm("")}}>
                    <i className='fas fa-arrow-left'></i>
                    Back
                </div>
                Add New Button
                <div className={styles.resetBtn} onClick={e => {e.preventDefault(); resetForm()}}>
                    Reset
                </div>
            </div>
            {Object.values(buttonData.type).length < 1 ?
                <ButtonSelector setAddObj={setButtonData} />
            :
                <>
                <ButtonTypeReturn profile_theme={profile_theme} addObj={buttonData} setAddObj={setButtonData} />
                <button 
                    onClick={saveNewButton} 
                    className={styles.saveBtn} 
                    disabled={buttonData.hasChanges === false || showSpinner || !buttonData.data}>
                    {showSpinner ? <i className="fa-thin fa-spinner fa-spin-pulse"></i> : 'Accept'}
                </button>
                </>
            }
        </div>
    );
};

export default AddButton;
